import React from 'react';

/**
 * Divider with dynamic fill color
 *
 * @example
 * <div className='text-red-50'><Divider /></div>
 */

export function Divider() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 343 1"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0.25C0 0.111929 0.111929 0 0.25 0H342.75C342.888 0 343 0.111929 343 0.25C343 0.388071 342.888 0.5 342.75 0.5H0.249994C0.111923 0.5 0 0.388071 0 0.25Z"
        fill="currentColor"
      />
    </svg>
  );
}
